<template>
  <div class="easy-copy checkbox-group">
    <input
      type="checkbox"
      id="sameAsPrevious"
      :checked="isChecked"
      :disabled="isDisabled"
      @click="onChange" />
    <label for="sameAsPrevious" style="cursor: pointer">
      <span class="previous-text"
        >Use the same settings from the previous item</span
      >
      <div class="previous-spec-image">
        <img class="" :src="previousImage" />
      </div>
    </label>
  </div>
</template>
<script setup lang="ts">
import { ref ,computed} from 'vue'

const props = defineProps({
  checked: {
    type: Boolean,
    default: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  previousImage: String
})
const emit = defineEmits(['change'])

const isChecked = computed(() => props.checked)
const isDisabled = computed(() => props.disabled)

const onChange = (event: MouseEvent) => {
  const target = event.target as HTMLInputElement
  emit('change', target.checked)
}
</script>
<style lang="less">
.checkbox-group {
  position: relative;

  input {
    display: none;
  }

  label {
    cursor: pointer;
    margin: 0;
    vertical-align: middle;
    display: inline-flex;
    font-weight: 500;
    align-items: center;

    &:before {
      content: '';
      width: 20px;
      height: 20px;
      margin: 0 8px;
      vertical-align: middle;
      display: inline-block;
      background: url(https://img66.anypromo.com/frontimg/2022/Icon/ico-choose-5.svg)
        no-repeat 0 0;
    }
  }
}

.checkbox-group input:checked + label:before {
  background: url(https://img66.anypromo.com/frontimg/2022/Icon/ico-choose-4.svg)
    no-repeat 0 0;
}

.checkbox-group input:disabled + label:before {
  background: url(https://img66.anypromo.com/frontimg/2022/Icon/ico-choose-6.svg)
    no-repeat 0 0;
  background-size: 20px 20px;
}

.checkbox-group input:checked:disabled + label:before {
  background: url(https://img66.anypromo.com/frontimg/2022/Icon/ico-choose-7.svg)
    no-repeat 0 0;
}
</style>
